import React from "react";
import SlideOutSidebar from "../../../ui-components/slide-out-sidebar/slideOutSidebar";
import { PickupsResponseContentModel } from "../../../app/data/pickup/models";
import "./documentViewer.scss";
import { PickupDocViewerInfo } from "./pickupDocViewerInfo";
import { PickupDocImageViewer } from "./pickupDocImageViewer";
import Button, { ButtonThemes } from "../../../ui-components/button/button";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiQueryAdapter } from "../../../app/data/apiQueryAdapter";
import { toast } from "react-toastify";
import moment from "moment-timezone";
import dateFormats from "../../../app/data/common/dateFormats";

// Helper function to convert GMT/UTC date string to local time and format
const formatDateFromGMT = (dateString: string | null | undefined): string | null => {
  if (!dateString) return null;
  return moment.utc(dateString).local().format(dateFormats.uiDateTime);
};
export interface PickupDocumentViewerProps {
  pickup: PickupsResponseContentModel | null;
  isOpen: boolean;
  onClose: any;
}

export const PickupDocumentViewer: React.FC<PickupDocumentViewerProps> = (props) => {
  const queryClient = useQueryClient();

  const approvePickupMutation = useMutation(
    async () => {
      return await apiQueryAdapter.query<null>(`/pickups/billing/${props.pickup?.pickup.pickupId}/approve`, "POST", {
      });
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['pickup_approvement']);
        toast.info("Pickup approved");
        props.onClose();
      },
      onError: (error) => {
        toast.error(error);
      },
    }
  );
  
  const handleApprovePickup = () => {
    approvePickupMutation.mutate();
  };

  const isAlreadyConfirmed = !!props.pickup?.billingApprovedDate;
  
  const documents = props.pickup?.pickupFullData.pickupRequest?.documents?.map((image, index) => ({
    src: image.storageUrl,
    fileType: image.fileType,
    alt: `Document ${index + 1}`,
    type: `Scan ${String(index + 1).padStart(2, '0')}`
  })) || [];
  
  return (
    <SlideOutSidebar show={props.isOpen} onClose={props.onClose} header={"BOL Pictures"} >
      <PickupDocViewerInfo pickup={props.pickup} />
      {!documents.length && <div className="xgs-pickup-doc-viewer__no-docs">No documents found</div>}
      {documents.length > 0 && <PickupDocImageViewer documents={documents} />}
      {isAlreadyConfirmed && (
        <div className="xgs-pickup-doc-viewer__already-confirmed">
          Already confirmed on {formatDateFromGMT(props.pickup?.billingApprovedDate)} by {props.pickup?.billingApprovedUser}
        </div>
      )}
      <div className="xgs-pickup-doc-viewer__buttons">
        <Button
          theme={ButtonThemes.blue}
          onClick={handleApprovePickup}
          spinner={approvePickupMutation.isLoading}
          disabled={isAlreadyConfirmed || approvePickupMutation.isLoading}
        >
          Confirm Probill
        </Button>
        <Button
          theme={ButtonThemes.gray}
          onClick={() => props.onClose()}
          disabled={approvePickupMutation.isLoading}
        >
          Cancel
        </Button>
      </div>
    </SlideOutSidebar>
  )
}
